<nav class="navbar navbar-expand-lg navbar-dark bg-dark mb-3 sticky-top" *ngIf="currentUser">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/" routerLinkActive="active">IE Pay</a>

    <!-- Step 3: Toggle the value of the property when the toggler button is clicked. -->
    <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
      &#9776;
    </button>
    <!-- Step 2: Add the ngbCollapse directive to the element below. -->
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto" *ngIf="currentUser.roleName == 'CLIENT'">
        <li class="nav-item">
          <a routerLinkActive="active" class="nav-item nav-link" routerLink="c/subscriber">Subscribers</a>
        </li>
        <li class="nav-item">
          <a routerLinkActive="active" class="nav-item nav-link" routerLink="c/mo-log">MOs</a>
        </li>
        <li class="nav-item">
          <a routerLinkActive="active" class="nav-item nav-link" routerLink="c/dn-log">DNs</a>
        </li>
      </ul>
      <ul class="navbar-nav mr-auto" *ngIf="currentUser.roleName != 'CLIENT'">

        <li class="nav-item" *ngIf="currentUser.roleName == 'ADMIN'">
          <a routerLinkActive="active" class="nav-item nav-link" routerLink="clients">Clients</a>
        </li>
        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="keywordMenu" role="button"
            [class.active]="router.isActive('/dashboard/keyword', true) || router.isActive('/dashboard/keyword-advance', true)">
            Keywords
          </a>
          <div ngbDropdownMenu aria-labelledby="keywordMenu" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="keyword">Console</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="keyword-advance">Console+</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="logsMenu" role="button"
          [class.active]="router.isActive('/dashboard/spider/schedule', true) || router.isActive('/dashboard/spider/account', true) || router.isActive('/dashboard/mo-log', true) || router.isActive('/dashboard/dn-log', true) || router.isActive('/dashboard/subscriber', true) || router.isActive('/dashboard/mo-record', true) || router.isActive('/dashboard/dn-record', true)">
            Logs
          </a>
          <div ngbDropdownMenu aria-labelledby="logsMenu" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="mo-log">MO Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="dn-log">DN Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="subscriber">Subscriber Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="mo-record">3rd-MO Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="dn-record">3rd-DN Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="spider/account">Spider Account</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="spider/schedule">Spider Schedule</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="reports" role="button"
            [class.active]="router.isActive('/dashboard/summary/schedule', true) || router.isActive('/dashboard/sms-count', true) || router.isActive('/dashboard/multi-sub', true) ||router.isActive('/dashboard/dn-charge', true) || router.isActive('/dashboard/dn-performance', true) || router.isActive('/dashboard/mo-quality-assessment', true) || router.isActive('/dashboard/subscription-performance', true) || router.isActive('/dashboard/retention', true)">
            Reports
          </a>
          <div ngbDropdownMenu aria-labelledby="reports" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="dn-charge">Dn Charge</a>

            <a ngbDropdownItem routerLinkActive="active" routerLink="dn-performance">DN Performance</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="subscription-performance">Subscription Performance</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="retention">Retention</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="mo-quality-assessment">Mo Quality Assessment</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="sms-count">SMS Count</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="multi-sub">Multiple Subscriber</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="summary/schedule">Summary Schedule</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="payout" role="button"
            [class.active]="router.isActive('/dashboard/revenue/payout/records', true) || router.isActive('/dashboard/revenue/share-ratio', true) ||router.isActive('/dashboard/revenue/payout/report', true) ||router.isActive('/dashboard/revenue/payout/upload', true) ||router.isActive('/dashboard/revenue/report-compatible', true) || router.isActive('/dashboard/revenue/report', true)">
            Revenue
          </a>
          <div ngbDropdownMenu aria-labelledby="payout" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/report">DN Revenue</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/report-compatible">DN Revenue Summer</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/payout/report">坏账报表</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/payout/records">坏账记录</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/payout/upload">坏账上传</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="revenue/share-ratio">分成占比分析</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="streamData" role="button"
            [class.active]="router.isActive('/dashboard/stream/keyword-guide', true) ||router.isActive('/dashboard/stream/history', true) || router.isActive('/dashboard/stream/report', true) || router.isActive('/dashboard/stream/keyword', true)">
            Stream
          </a>
          <div ngbDropdownMenu aria-labelledby="streamData" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="stream/report">Daily Report</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="stream/history">History</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="stream/keyword">Keyword Console</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="stream/keyword-guide">Keyword Guide</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="streamData" role="button"
            [class.active]="router.isActive('/dashboard/offer-stream/advertiser', true) ||router.isActive('/dashboard/offer-stream/history', true)">
           Offer Stream
          </a>
          <div ngbDropdownMenu aria-labelledby="streamData" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="offer-stream/advertiser">Advertiser</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="offer-stream/history">History</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="txData" role="button"
            [class.active]="router.isActive('/dashboard/tx/mo-log', true) || router.isActive('/dashboard/tx/mt-log', true) || router.isActive('/dashboard/tx/subscriber', true) || router.isActive('/dashboard/tx/content', true) || router.isActive('/dashboard/tx/keyword', true) || router.isActive('/dashboard/tx/sc-msg', true)">
            SP Funcs
          </a>
          <div ngbDropdownMenu aria-labelledby="txData" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/mo-log">AoC & MO Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/mt-log">MT & Broadcast Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/subscriber">Subscriber Data</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/keyword">Keyword Console</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/content">Content Console</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="tx/sc-msg">ShortCode Msg Console</a>
          </div>
        </li>

        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-left">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="support" role="button"
            [class.active]="router.isActive('/dashboard/premium-service/meta', true) || router.isActive('/dashboard/support/3rdparty', true) ||router.isActive('/dashboard/support/tx-kw', true) ||router.isActive('/dashboard/support/schedule', true) ||router.isActive('/dashboard/support/msg-template', true) ||router.isActive('/dashboard/support/res-list', true)">
            Support
          </a>
          <div ngbDropdownMenu aria-labelledby="support" class="dropdown-menu">
            <a ngbDropdownItem routerLinkActive="active" routerLink="support/3rdparty">3rd Party Notes</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="support/tx-kw">Add Keyword Guide</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="support/schedule">Schedule Guide</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="support/msg-template">Message Template Guide</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="support/res-list">Resource List</a>
            <a ngbDropdownItem routerLinkActive="active" routerLink="premium-service/meta">Premium Service</a>
          </div>
        </li>
        <li class="nav-item">
          <a  class="nav-item nav-link" *ngIf="!isFullScreen" (click)="openFullscreen()">FullScreen</a>
          <a  class="nav-item nav-link" *ngIf="isFullScreen" (click)="closeFullscreen()">Exit FullScreen</a>
        </li>
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-right">
          <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="navbarDropdown3" role="button"
            [class.active]="router.isActive('/dashboard/profile', true)">
            {{currentUser.username}} <span *ngIf="currentUser.roleName != 'CLIENT'">({{currentUser.roleName}})</span>
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdown3" class="dropdown-menu">
            <a ngbDropdownItem routerLink="profile" routerLinkActive="active">Profile</a>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div [@routeAnimations]="prepareRoute(outlet)" class="container-fluid mt-3 position-relative">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<footer class="page-footer mt-3 position-relative">
  <p class="text-center footer-copyright"><i class="fa fa-copyright" aria-hidden="true"></i> {{currentYear}} Copyright: <span
      class="text-uppercase">Intelligent Earnings</span></p>
  <p class="text-center">
    <span class="text-info font-weight-bold font-italic">Life is short, I use IE Pay.</span>
    <br>
  </p>
</footer>
